const RV_KEY = 'rv_product_ids';

export function trackRecentlyViewed(productId: number) {
  try {
    const stored = localStorage.getItem(RV_KEY);
    const ids: number[] = stored ? JSON.parse(stored) : [];
    const next = [productId, ...ids.filter(id => id !== productId)].slice(0, 20);
    localStorage.setItem(RV_KEY, JSON.stringify(next));
  } catch { /* ignore */ }
}

export function getRecentlyViewedIds(limit = 20): number[] {
  try {
    const stored = localStorage.getItem(RV_KEY);
    return stored ? (JSON.parse(stored) as number[]).slice(0, limit) : [];
  } catch { return []; }
}
